import { getNavConfigForRoles } from "../layouts/nav/config";
import { pickPrimaryRole } from "./rolePriority";

export const billingAccessRoutes = [
  "/payments",
  "/clinic-pet-details",
  "/appointments",
  "/inventory",
];
export const inventoryAccessRoutes = ["/inventory"];
export const groomerAccessRoutes = ["/groomdashboard", "/groom-pet-details"];
export const labAccessRoutes = ["/labdashboard", "/lab-pet-details"];
export const pharmacyAccessRoutes = [
  "/phramacydashboard",
  "/pharmacy-pet-details",
];

const UNRESTRICTED_ROUTE_ROLES = new Set([
  "ROLE_ADMIN",
  "ROLE_CLINIC",
  "ROLE_CLINICSUPERADMIN",
]);

const MODULE_DETAIL_ROUTE_PREFIXES = [
  "/clinic-pet-details",
  "/groom-pet-details",
  "/lab-pet-details",
  "/pharmacy-pet-details",
  "/settings",
  "/vet-calendar",
  "/manage-availability",
  "/clinic-consultation",
];

const ROLE_DEFAULT_ROUTES = {
  ROLE_BILLING: "/payments",
  ROLE_INVENTORY: "/inventory",
  ROLE_GROOMER: "/groomdashboard",
  ROLE_RADIOLOGY: "/labdashboard",
  ROLE_PHARMACY: "/phramacydashboard",
};

export const parseAllRoles = () => {
  try {
    const stored = localStorage.getItem("allRoles");
    if (!stored) {
      const role = localStorage.getItem("role");
      return role ? [role] : [];
    }
    const parsed = JSON.parse(stored);
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
    return stored ? [stored] : [];
  } catch {
    const stored = localStorage.getItem("allRoles");
    if (stored?.includes(",")) {
      return stored
        .split(",")
        .map((role) => role.trim())
        .filter(Boolean);
    }
    const role = localStorage.getItem("role");
    return stored ? [stored] : role ? [role] : [];
  }
};

export const getPrimaryRole = (roles = parseAllRoles()) =>
  pickPrimaryRole(roles) || localStorage.getItem("role") || "";

export const isPathAllowedForRoles = (path, roles = parseAllRoles()) => {
  if (!path) return false;

  const primaryRole = getPrimaryRole(roles);
  if (UNRESTRICTED_ROUTE_ROLES.has(primaryRole)) {
    return true;
  }

  const navPaths = getNavConfigForRoles(roles).map((item) => item.path);
  const allowedPrefixes = [...navPaths, ...MODULE_DETAIL_ROUTE_PREFIXES];

  return allowedPrefixes.some(
    (allowedPath) => path === allowedPath || path.startsWith(`${allowedPath}/`),
  );
};

export const getDefaultRouteForRoles = (roles = parseAllRoles()) => {
  const navPaths = getNavConfigForRoles(roles).map((item) => item.path);
  if (navPaths.length > 0) {
    return navPaths[0];
  }

  const primaryRole = getPrimaryRole(roles);
  if (primaryRole && ROLE_DEFAULT_ROUTES[primaryRole]) {
    return ROLE_DEFAULT_ROUTES[primaryRole];
  }

  return "/dashboard";
};
